import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import {
	loadHasViewedPulseService,
	setHasViewedPulseService,
} from '../../../services/whiteboards-entrypoint-experiment';
import { LOAD_APP_DATA_REQUEST } from '../../../state/actions/app';
import {
	hasPulseViewedEstablished,
	SET_HAS_PULSE_VIEWED_REQUEST,
} from '../../../state/actions/whiteboards-entrypoint-experiment';
import { getAtlassianAccountId } from '../../../state/selectors/app';
import type { ActionsObservable, MiddlewareAPI } from '../../../state/types';

const loadHasViewedPulse = ({ store }: { store: MiddlewareAPI }) => {
	const accountId = getAtlassianAccountId(store.getState());
	return loadHasViewedPulseService(accountId ?? '').map(hasPulseViewedEstablished);
};

export const loadHasViewedPulseEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(LOAD_APP_DATA_REQUEST).flatMap(() => loadHasViewedPulse({ store }));

export const setHasViewedPulseEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(SET_HAS_PULSE_VIEWED_REQUEST).flatMap(() => setHasViewedPulseService({ store }));
